
export default {
  props: {
    code: {
      type: Number,
      required: true
    }
  },
  emits: ['cancel']
}
